import { AmbassadorError, DispatchEmptyObject, DispatchObject } from '@/models/globalModels';
import { TaxContext } from '@/models/taxModels';
import ApiService from '@/services/ApiService';

import { RootState } from '../../rootReducer';
import * as t from '../types';

export const doGetTaxContext = () => (dispatch: any, getState: () => RootState) => {
  const { auth } = getState();
  const uid = auth.ambassadorProfile?.uid;
  if (!uid) return;
  dispatch(doTaxContextFetching());
  ApiService.getTaxContext(uid)
    .then((taxContext) => {
      dispatch(doTaxContextFetch(taxContext));
    })
    .catch((e) => dispatch(doTaxContextFetchError(e)));
};

export const doTaxContextFetching = () => (dispatch: DispatchEmptyObject) => {
  dispatch({
    type: t.GET_TAX_CONTEXT_FETCHING,
  });
};

export const doTaxContextFetch = (taxContext: TaxContext) => (dispatch: DispatchObject<TaxContext>) => {
  dispatch({
    type: t.GET_TAX_CONTEXT_FETCH,
    payload: taxContext,
  });
};

export const doTaxContextFetchError = (error: AmbassadorError) => (dispatch: DispatchObject<AmbassadorError>) => {
  dispatch({
    type: t.GET_TAX_CONTEXT_FETCH_ERROR,
    payload: { ...error },
  });
};

export const doResetTaxContext = () => (dispatch: DispatchEmptyObject) => {
  dispatch({
    type: t.RESET_TAX_CONTEXT,
  });
};
